import UserDirectoryComponent from '../UserDirectoryComponent.vue'
import UserKpisComponent from '../UserKpisComponent.vue'

export default [
    {
        path: '/directory',
        name: 'UserDirectory',
        meta: { layout: 'default' },
        component: UserDirectoryComponent,
    },
    {
        path: '/directory/:userId/kpis',
        name: 'UserKpis',
        meta: { layout: 'default' },
        component: UserKpisComponent,
    },
]
